import { name } from "file-loader";

/**
 * Created by PursuitStar on 2019/03/12
 * Desc: 经销商项目路由表配置
 */
const _import = require('./_import_' + process.env.NODE_ENV);
const agentProjectRoute = [
  // 表单组件-示例demo
  {
    path: '/formDemo',
    name: 'formDemo',
    component: _import('agent/formDemo/index'),
    hidden: true,
    meta: {
      title: '表单组件demo'
    }
  },
  /* =================== 入驻模块 =================== */
  {
    path: '/enterApply/tips',
    name: 'apply_instruction',
    component: _import('agent/agentEnter/tips/index'),
    hidden: true,
    meta: {
      title: '入驻须知'
    }
  },
  {
    path: '/enterApply/authType',
    name: 'apply_authType',
    component: _import('agent/agentEnter/authenticationMode/index'),
    hidden: true,
    meta: {
      title: '选择认证方式'
    }
  },
  {
    path: '/enterApply/applyProcess',
    name: 'apply_authType',
    component: _import('agent/agentEnter/applyProcess/index'),
    hidden: true,
    meta: {
      title: '申请流程'
    }
  },
  {
    path: '/enterApply/applyProcessWebsite',
    name: 'apply_process_website',
    component: _import('agent/agentEnter/applyProcessWebsite/index'),
    hidden: true,
    meta: {
      title: '网站列表'
    }
  },
  {
    path: '/enterApply/abroad',
    name: 'apply_abroad',
    component: _import('agent/agentEnter/abroadMode/index'),
    hidden: true,
    meta: {
      title: '海外入驻'
    }
  },
  {
    path: '/enterApply/phone',
    name: 'apply_phone',
    component: _import('agent/agentEnter/mobileMode/index'),
    hidden: true,
    meta: {
      title: '自然人认证'
    }
  },
  {
    path: '/enterApply/card',
    name: 'apply_card',
    component: _import('agent/agentEnter/bankCardMode/index'),
    hidden: true,
    meta: {
      title: '自然人认证'
    }
  },
  {
    path: '/enterApply/person',
    name: 'apply_person',
    component: _import('agent/agentEnter/personMode/index'),
    hidden: true,
    meta: {
      title: '个体工商户认证'
    }
  },
  {
    path: '/enterApply/enterprise',
    name: 'apply_enterprise',
    component: _import('agent/agentEnter/enterpriseMode/index'),
    hidden: true,
    meta: {
      title: '企业认证'
    }
  },{
    path: '/enterApply/informationPerfection',
    name: 'apply_informationPerfection',
    component: _import('agent/agentEnter/informationPerfection/index'),
    hidden: true,
    meta: {
      title: '信息完善'
    }
  },
  {
    path: '/enterApply/contract',
    name: 'apply_contract',
    component: _import('agent/agentEnter/contract/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },
  {
    path: '/enterApply/sign',
    name: 'apply_sign',
    component: _import('agent/agentEnter/sign/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },
  /* =================== 公共资源【协议/收据/合同/证书】 =================== */
  {
    path: '/pages/agreement',
    name: 'user_service_protocol',
    component: _import('agent/static_file/user_service_protocol/index'),
    hidden: true,
    meta: {
      title: '用户服务协议'
    }
  },
  {
    path: '/privacyPolicy',
    name: 'privacy_policy',
    component: _import('agent/static_file/privacy_policy/index'),
    hidden: true,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/accountProtocol',
    name: 'account_protocol',
    component: _import('agent/static_file/account_protocol/new_index2'),
    hidden: true,
    meta: {
      title: '账户协议'
    }
  },
  // 此公告，一次性文件
  {
    path: '/noticeOne',
    name: 'noticeOne',
    component: _import('agent/static_file/notice/index'),
    hidden: true,
    meta: {
      title: '公告'
    }
  },
  {
    path: '/agentProtocol',
    name: 'agent_protocol',
    component: _import('agent/static_file/agent_protocol/index'),
    hidden: true,
    meta: {
      title: '管家服务协议'
    }
  },
  {
    path: '/agentCloudStorageProtocol',
    name: 'agent_cloud_storage_protocol',
    component: _import('agent/static_file/agent_cloud_storage_protocol/index'),
    hidden: true,
    meta: {
      title: '代理商云仓服务协议'
    }
  },
  {
    path: '/signatory/contractdetail',
    name: 'signatory_contractdetail',
    component: _import('agent/static_file/contractdetail/index'),
    hidden: true,
    meta: {
      title: '收据详情'
    }
  },
  {
    path: '/signatory/certificate',
    name: 'signatory_certificate',
    component: _import('agent/static_file/certificate/index'),
    hidden: true,
    meta: {
      title: '电子证书'
    }
  },
  {
    path: '/signatory/elecContract',
    name: 'signatory_elecContract',
    component: _import('agent/static_file/elecContract/index'),
    hidden: true,
    meta: {
      title: '电子合同'
    }
  },
  {
    path: '/lifeSignatory/contract',
    name: 'lifeSignatory_contract',
    component: _import('agent/lifeSignatory/contract/index'),
    hidden: true,
    meta: {
      title: '英树生活服务协议'
    }
  },
  {
    path: '/lifeSignatory/sign',
    name: 'lifeSignatory_sign',
    component: _import('agent/lifeSignatory/sign/index'),
    hidden: true,
    meta: {
      title: '英树生活服务协议'
    }
  },
  {
    path: '/lifeSignatory/success',
    name: 'lifeSignatory_success',
    component: _import('agent/lifeSignatory/success/index'),
    hidden: true,
    meta: {
      title: '签署完成'
    }
  },

  {
    path: '/signatory/list',
    name: 'signatory_list',
    component: _import('agent/signatoryList/index'),
    hidden: true,
    meta: {
      title: '平台协议'
    }
  },

  /* =================== 完善信息模块 =================== */
  {
    path: '/infomation/phone',
    name: 'infomation_phone',
    component: _import('agent/completionInformation/mobileMode/index'),
    hidden: true,
    meta: {
      title: '自然人认证'
    }
  },
  {
    path: '/infomation/card',
    name: 'infomation_card',
    component: _import('agent/completionInformation/bankCardMode/index'),
    hidden: true,
    meta: {
      title: '自然人认证'
    }
  },
  {
    path: '/infomation/person',
    name: 'infomation_person',
    component: _import('agent/completionInformation/personMode/index'),
    hidden: true,
    meta: {
      title: '个体工商户认证'
    }
  },
  {
    path: '/infomation/enterprise',
    name: 'infomation_enterprise',
    component: _import('agent/completionInformation/enterpriseMode/index'),
    hidden: true,
    meta: {
      title: '企业认证'
    }
  },
  {
    path: '/infomation/sign',
    name: 'infomation_sign',
    component: _import('agent/completionInformation/sign/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },
  // {
  //     path: '/infomation/upPerson', //升级-完善信息
  //     name: 'infomation_upPerson',
  //     component: _import('agent/completionInformation/upPersonMode/index'),
  //     hidden: true,
  //     meta: { title: '个体工商户认证' }
  // },
  {
    path: '/infomation/upEnterprise', //升级-完善信息
    name: 'infomation_upEnterprise',
    component: _import('agent/completionInformation/upEnterpriseMode/index'),
    hidden: true,
    meta: {
      title: '企业认证'
    }
  },
  {
    path: '/infomation/uploadBusinessLicense', //完善信息-上传营业执照
    name: 'infomationUploadBusinessLicense',
    component: _import('agent/completionInformation/uploadBusinessLicense/index'),
    hidden: true,
    meta: {
      title: '更新营业执照信息'
    }
  }, {
    path: '/infomation/uploadID', //完善信息-上传法人身份证信息
    name: 'uploadID',
    component: _import('agent/completionInformation/uploadID/index'),
    hidden: true,
    meta: {
      title: '更新身份证信息'
    }
  },
  {
    path: '/infomation/modifyInfo', //完善信息-更新信息
    name: 'modify_info',
    component: _import('agent/completionInformation/modifyInfoMode/index'),
    hidden: true,
    meta: {
      title: '更新信息'
    }
  },

  /* =================== 降级模块 =================== */
  {
    path: '/demotion/contract',
    name: 'demotion_contract',
    component: _import('agent/downgradeAgent/contract/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },
  {
    path: '/demotion/sign',
    name: 'demotion_sign',
    component: _import('agent/downgradeAgent/sign/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },
  /* =================== 续签模块 =================== */
  {
    path: '/renew/contract',
    name: 'renew_contract',
    component: _import('agent/renewAgent/contract/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },
  {
    path: '/renew/sign',
    name: 'renew_sign',
    component: _import('agent/renewAgent/sign/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },

  /* =================== 升级模块 =================== */
  {
    path: '/adjust/payfees',
    name: 'adjust_payfees',
    component: _import('agent/upgradeAgent/payfees/index'),
    hidden: true,
    meta: {
      title: '补缴保证金'
    }
  },

  { //经销商合同
    path: '/upgradeAgent/contract',
    name: 'upgradeAgentContract',
    component: _import('agent/upgradeAgent/contract/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },
  { //以企业身份升级经销商
    path: '/upgradeAgent/enterpriseMode',
    name: 'upgradeAgentEnterprise',
    component: _import('agent/upgradeAgent/enterpriseMode/index'),
    hidden: true,
    meta: {
      title: '企业认证'
    }
  },
  { //以个体工商户身份升级经销商
    path: '/upgradeAgent/selfEmployedPersonalMode',
    name: 'upgradeSelfEmployedPersonalMode',
    component: _import('agent/upgradeAgent/selfEmployedPersonalMode/index'),
    hidden: true,
    meta: {
      title: '个体工商户入驻'
    }
  },
  { //签字
    path: '/upgradeAgent/signature',
    name: 'upgradeAgentSignature',
    component: _import('agent/upgradeAgent/signature/index'),
    hidden: true,
    meta: {
      title: '签署合同'
    }
  },
  { //补缴保证金
    path: '/upgradeAgent/payMoney',
    name: 'upgradeAgentpayMoney',
    component: _import('agent/upgradeAgent/payMoney/index'),
    hidden: true,
    meta: {
      title: '补缴保证金'
    }
  },

  /* =================== 终止合作模块 =================== */
  { //终止合作申请
    path: '/exitAgent/applySign',
    name: 'exitAgentApplySign',
    component: _import('agent/exitAgent/applySign/index'),
    hidden: true,
    meta: {
      title: '终止合作申请'
    }
  },
  { //终止合作协议
    path: '/exitAgent/returnDepositAgreement',
    name: 'returnDepositAgreement',
    component: _import('agent/exitAgent/returnDepositAgreement/index'),
    hidden: true,
    meta: {
      title: '终止合作协议'
    }
  },
  { //退保证金申请表
    path: '/exitAgent/returnDepositMoney',
    name: 'returnDepositMoney',
    component: _import('agent/exitAgent/returnDepositMoney/index'),
    hidden: true,
    meta: {
      title: '退保证金申请表'
    }
  },
  { //退保证金申请表
    path: '/exitAgent/signature',
    name: 'exitAgentSignature',
    component: _import('agent/exitAgent/signature/index'),
    hidden: true,
    meta: {
      title: '退保证金申请表'
    }
  },

  /* =================== 转让模块 =================== */
  { //转让协议
    path: '/transferAgent/transferAgreement',
    name: 'transferAgreement',
    component: _import('agent/transferAgent/transferAgreement/index'),
    hidden: true,
    meta: {
      title: '转让协议'
    }
  },
  { //转让为企业
    path: '/transferAgent/transferToEnterprise',
    name: 'transferToEnterprise',
    component: _import('agent/transferAgent/transferToEnterprise/index'),
    hidden: true,
    meta: {
      title: '企业认证'
    }
  },
  { //转让为企业上传营业执照
    path: '/transferAgent/uploadBusinessLicense',
    name: 'transferAgentUploadBusinessLicense1',
    component: _import('agent/transferAgent/uploadEnterpriseBusinessLicense/index'),
    hidden: true,
    meta: {
      title: '上传营业执照'
    }
  },
  { //转让为个体工商户
    path: '/transferAgent/transferToSelfEmployedPersonal',
    name: 'transferToSelfEmployedPersonal',
    component: _import('agent/transferAgent/transferToSelfEmployedPersonal/index'),
    hidden: true,
    meta: {
      title: '个体工商户认证'
    }
  },
  { //转让为个人  身份证认证
    path: '/transferAgent/transferToPersonal',
    name: 'transferToPersonal',
    component: _import('agent/transferAgent/transferToPersonal/index'),
    hidden: true,
    meta: {
      title: '自然人认证'
    }
  },
  { //转让为个人 银行卡认证
    path: '/transferAgent/transferToPersonalBankCard',
    name: 'transferToPersonalBankCard',
    component: _import('agent/transferAgent/transferToPersonalBankCard/index'),
    hidden: true,
    meta: {
      title: '自然人认证'
    }
  },
  { //转让方签名
    path: '/transferAgent/transferorSignature',
    name: 'transferorSignature',
    component: _import('agent/transferAgent/transferorSignature/index'),
    hidden: true,
    meta: {
      title: '确认签名'
    }
  },
  { //受让方签名
    path: '/transferAgent/assigneeSignature',
    name: 'assigneeSignature',
    component: _import('agent/transferAgent/assigneeSignature/index'),
    hidden: true,
    meta: {
      title: '确认签名'
    }
  },
  { //区域经理转让给城市经理商品 - 合同
    path: '/transferAgent/transferToCityManager',
    name: 'transferToCotyManager',
    component: _import('agent/transferAgent/transferToCityManager/index'),
    hidden: true,
    meta: {
      title: '签署转让协议'
    }
  },
  { //区域经理转让给城市经理商品 - 转让方/受让方签名
    path: '/transferAgent/transferorCitySignature',
    name: 'transferorSignature',
    component: _import('agent/transferAgent/transferorCitySignature/index'),
    hidden: true,
    meta: {
      title: '确认签名'
    }
  },
  { //区域经理转让给城市经理商品 - 成功页
    path: '/transferAgent/success',
    name: 'success',
    component: _import('agent/transferAgent/transferorCitySignature/success'),
    hidden: true,
    meta: {
      title: '签署完成'
    }
  },
  { //区域经理转让给城市经理商品确认函
    path: '/transferAgent/confirmationLetter',
    name: 'confirmationLetter',
    component: _import('agent/transferAgent/confirmationLetter/index'),
    hidden: true,
    meta: {
      title: '确认函'
    }
  },

  /* =================== 签约管理模块【暂时没用到】=================== */
  {
    path: '/signatory/signatoryHome',
    name: 'signatory_signatoryHome',
    component: _import('agent/signatory/signatoryHome/index'),
    hidden: true,
    meta: {
      title: '签约管理'
    }
  },
  {
    path: '/signatory/signatorydetails',
    name: 'signatory_signatorydetails',
    component: _import('agent/signatory/signatorydetails/index'),
    hidden: true,
    meta: {
      title: '签约详情'
    }
  },
  {
    path: '/signatory/applydetails',
    name: 'signatory_applydetails',
    component: _import('agent/signatory/applydetails/index'),
    hidden: true,
    meta: {
      title: '申请详情'
    }
  },
  {
    path: '/signatory/collectTask',
    name: 'signatory_collectTask',
    component: _import('agent/signatory/collectTask/index'),
    hidden: true,
    meta: {
      title: '首单任务'
    }
  },
  {
    path: '/signatory/collectTaskCart',
    name: 'signatory_collectTaskCart',
    component: _import('agent/signatory/collectTaskCart/index'),
    hidden: true,
    meta: {
      title: '采购首单'
    }
  },
  // {
  //     path: '/signatory/buySucceed',
  //     name: 'signatory_buySucceed',
  //     component: _import('agent/signatory/buySucceed/index'),
  //     hidden: true,
  //     meta: { title: '首单任务_购买成功' }
  // },
  // {
  //     path: '/signatory/subcontract',
  //     name: 'signatory_subcontract',
  //     component: _import('agent/signatory/subcontract/index'),
  //     hidden: true,
  //     meta: { title: '采购方签约' }
  // },

  /* =================== 经销商模块【暂时没用到】=================== */
  {
    path: '/powder/mypowder',
    name: 'powder_mypowder',
    component: _import('agent/powder/mypowder/index'),
    hidden: true,
    meta: {
      title: '我的经销商'
    }
  },
  {
    path: '/powder/powderdetails',
    name: 'powder_powderdetails',
    component: _import('agent/powder/powderdetails/index'),
    hidden: true,
    meta: {
      title: '业绩预览'
    }
  },
  // {
  //     path: '/powder/powderinvite',
  //     name: 'powder_powderInvite',
  //     component: _import('agent/powder/powderinvite/index'),
  //     hidden: true,
  //     meta: { title: '邀请经销商' }
  // },
  {
    path: '/powder/contractDetails',
    name: 'powder_contractDetails',
    component: _import('agent/powder/contractDetails/index'),
    hidden: true,
    meta: {
      title: '签约详情'
    }
  },
  {
    path: '/powder/evaluation',
    name: 'powder_evaluation',
    component: _import('agent/powder/evaluation/index'),
    hidden: true,
    meta: {
      title: '提交众评'
    }
  },
  {
    path: '/powder/sponsor',
    name: 'powder_sponsor',
    component: _import('agent/powder/sponsor/index'),
    hidden: true,
    meta: {
      title: '申请/发起降级'
    }
  },
  /* =================== 经销协议签署=================== */
  {
    path: '/sellContract/contract',
    name: 'sell_contract',
    component: _import('agent/sellContract/contract/index'),
    hidden: true,
    meta: {
      title: '经销协议'
    }
  },
  {
    path: '/sellContract/sign',
    name: 'sell_sign',
    component: _import('agent/sellContract/sign/index'),
    hidden: true,
    meta: {
      title: '经销协议'
    }
  },
  {
    path: '/sellContract/success',
    name: 'sell_success',
    component: _import('agent/sellContract/success/index'),
    hidden: true,
    meta: {
      title: '经销协议'
    }
  },
  /* =================== 新政1签署=================== */
  {
    path: '/policy/contract',
    name: 'policy_contract',
    component: _import('agent/policySign/contract/index'),
    hidden: true,
    meta: {
      title: '英树管家服务协议'
    }
  },
  {
    path: '/policy/sign',
    name: 'policy_sign',
    component: _import('agent/policySign/sign/index'),
    hidden: true,
    meta: {
      title: '英树管家服务协议'
    }
  },
  {
    path: '/policy/success',
    name: 'policy_success',
    component: _import('agent/policySign/success/index'),
    hidden: true,
    meta: {
      title: '协议签署成功'
    }
  },
  {
    path: '/policy/seePdf',
    name: 'policy_seePdf',
    component: _import('agent/policySign/seePdf/index'),
    hidden: true,
    meta: {
      title: '英树管家服务协议'
    }
  },{
    path:'/sign/result',
    name:'signResult',
    component:_import('agent/signResult/result/index'),
    hidden:true,
    meta:{
      title:'签署结果'
    }
  },{
    path:'/sign/seePdf',
    name:'signResult',
    component:_import('agent/signResult/seePdf/index'),
    hidden:true,
    meta:{
      title:'签署预览'
    }
  },
  //==============云仓清仓确认函=============
  {
    path: '/clear/contract',
    name: 'clear_contract',
    component: _import('agent/clearStorcksSign/contract/index'),
    hidden: true,
    meta: {
      title: '代理确认函'
    }
  },
  {
    path: '/clear/sign',
    name: 'clear_sign',
    component: _import('agent/clearStorcksSign/sign/index'),
    hidden: true,
    meta: {
      title: '确认签字'
    }
  },
  {
    path: '/clear/success',
    name: 'clear_success',
    component: _import('agent/clearStorcksSign/success/index'),
    hidden: true,
    meta: {
      title: '签署完成'
    }
  },

  // 生活特约开户等信心完善流程 --- 新
  {
    path: '/lifeTYEnter/verifyPhone',
    name: 'lifeTYVerifyPhone',
    component: _import('agent/lifeTeyueEnter/verifyPhone/index'),
    hidden: true,
    meta: {
      title: '验证登录手机'
    }
  },
  {
    path: '/lifeTYEnter/accountOpen',
    name: 'lifeTYAccountOpenCertification',
    component: _import('agent/lifeTeyueEnter/accountOpenCertification/index'),
    hidden: true,
    meta: {
      title: '申请流程'
    }
  },
  {
    path: '/lifeTYEnter/signingPreview',
    name: 'lifeTYSigningPreview',
    component: _import('agent/lifeTeyueEnter/signingPreview/index'),
    hidden: true,
    meta: {
      title: '申请流程'
    }
  },
  {
    path: '/lifeTYEnter/signContract',
    name: 'lifeTYSignContract',
    component: _import('agent/lifeTeyueEnter/signContract/index'),
    hidden: true,
    meta: {
      title: '申请流程'
    }
  },
  {
    path: '/lifeTYEnter/success',
    name: 'lifeTYSuccess',
    component: _import('agent/lifeTeyueEnter/success/index'),
    hidden: true,
    meta: {
      title: '申请流程'
    }
  },
  {
    path: '/eAccount/agreement',
    name: 'eAccountAgreement',
    component: _import('eAccountAgreement/index'),
    hidden: true,
    meta: {
      title: '“ e账户 ” 注册会员号管理协议'
    }
  }



  //     path: '/powder/suggest',
  //     name: 'powder_suggest',
  //     component: _import('agent/powder/suggest/index'),
  //     hidden: true,
  //     meta: { title: '提交意见' }
  // },
];
export default agentProjectRoute;



// WEBPACK FOOTER //
// ./src/router/agentProject.js